import { render, staticRenderFns } from "./djlList.vue?vue&type=template&id=28e0a68f&scoped=true&"
import script from "./djlList.vue?vue&type=script&lang=js&"
export * from "./djlList.vue?vue&type=script&lang=js&"
import style0 from "./djlList.vue?vue&type=style&index=0&id=28e0a68f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0a68f",
  null
  
)

export default component.exports